// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__2EW8f","rotate":"Spinner_rotate__1cJZM"};